export default __webpack_public_path__ + "static/media/cancel-transaction.ff1a5b58.svg";